// src/components/CustomTabs.js

import React, { useState } from 'react';
import { Tabs, Tab, Box, Typography, Grid } from '@mui/material';
import { styled } from '@mui/system';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SoftTypography from "components/SoftTypography";
import  "./style.css";

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  borderRadius: '8px',
  padding: '12px 16px',
  margin: '0 4px',
  backgroundColor: '#f0f0f0',
  transition: 'background-color 0.3s, color 0.3s',
  '&.Mui-selected': {
    backgroundColor: '#6200ea', // Active tab background color
      color: 'white !important'
  },
  '&:hover': {
    backgroundColor: '#e0e0e0',
     color: 'black !important'
  },
}));

const CustomTabs = ({ tabsData }) => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div style={{position:"relative"}}>
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <Grid container >
        
        <Grid item xs={12}>
          <Box sx={{ p: 0 }}>
            {tabsData.map((tab, index) => (
          <Accordion key={index} style={{marginBottom:"10px",width: "100%",
            padding: "5px 10px",
            opacity: "0px",
            border:"1px solid rgba(229, 229, 229, 1)",
            borderRadius:"15px",
            
            }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <SoftTypography ><span style={{color:"black",fontWeight:"bold"}}>{tab.label}</span></SoftTypography>
            </AccordionSummary>
            <AccordionDetails>
              <SoftTypography>
                {tab.content}
              </SoftTypography>
            </AccordionDetails>
          </Accordion>
        ))}
          </Box>
        </Grid>
      </Grid>
    </Box>
    </div>
  );
};

export default CustomTabs;
